import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Section, Box, Text, Table, TextField, Flex, Button } from '@radix-ui/themes';
import { SelectBox } from 'components/form';
import Editor from 'components/editor';
import PageTitle from 'components/layout/PageTitle';
// 실태조사 관리 > 등록 (웹 마스터 관리자 전용)
export default function RealSurveyWrite() {
  const [selectedValueYear, setSelectedValueYear] = useState('');
  const [selectedValueRegion, setSelectedValueRegion] = useState('');
  const [content, setContent] = useState('');
  const navigate = useNavigate();

  return (
    <Section>
      <PageTitle title="지역 디지털 산업 생태계 실태조사 등록" />
      <Box className="box box-white">
        <Box mb="var(--space-10)">
          <Table.Root className="table-write">
            <Table.Body>
              <Table.Row align="center">
                <Table.ColumnHeaderCell colSpan={2}>
                  <Text className="required-start">제목</Text>
                </Table.ColumnHeaderCell>
                <Table.Cell colSpan={10}>
                  <Text as="label" htmlFor="title">
                    <TextField.Root size="2" id="title" placeholder="제목을 입력해 주세요." />
                  </Text>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
            <Table.Body>
              <Table.Row align="center">
                <Table.ColumnHeaderCell colSpan={2}>
                  <Text className="required-start">데이터 년도</Text>
                </Table.ColumnHeaderCell>
                <Table.Cell colSpan={10}>
                  <SelectBox
                    size="2"
                    placeholder="데이터 년도를 선택해 주세요."
                    value={selectedValueYear}
                    options={['2020년', '2021년', '2022년', '2023년', '2024년']}
                    onChange={value => setSelectedValueYear(value)}
                  />
                </Table.Cell>
              </Table.Row>
            </Table.Body>
            <Table.Body>
              <Table.Row align="center">
                <Table.ColumnHeaderCell colSpan={2}>
                  <Text className="required-start">지역</Text>
                </Table.ColumnHeaderCell>
                <Table.Cell colSpan={10}>
                  <SelectBox
                    size="2"
                    placeholder="지역을 선택해 주세요."
                    value={selectedValueRegion}
                    options={['서울', '대전', '세종']}
                    onChange={value => setSelectedValueRegion(value)}
                  />
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table.Root>
        </Box>

        <Box>
          <Text as="p" className="sub-title1">
            데이터
          </Text>
          <Text color="gray" mt="var(--space-1)" className="body3">
            * 지역에서 해결하고 싶은 현안 또는 지역 내부에서 논의되고 있는 현안
          </Text>
          <Box mt="var(--space-4)">
            <Editor editorData={content} setEditorData={setContent} />
          </Box>
        </Box>
      </Box>

      {/* 페이지 버튼 */}
      <Box>
        <Flex justify="end" gap="2">
          <Button>저장</Button>
          <Button
            variant="outline"
            onClick={() => {
              navigate('/realSurvey');
            }}
          >
            취소
          </Button>
        </Flex>
      </Box>
    </Section>
  );
}
